import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {ITaskSlug} from '../../dto/Task.dto';

interface TaskState {
  parentSlug: ITaskSlug | null;
  childSlug: ITaskSlug | null;
}

const initialState: TaskState = {
  parentSlug: null,
  childSlug: null,
};

export const taskInnerSwitchSlice = createSlice({
  name: 'taskInnerSwitch',
  initialState,
  reducers: {
    setParentSlug: (state, action: PayloadAction<ITaskSlug>) => {
      state.parentSlug = action.payload;
    },
    resetParentSlug: state => {
      state.parentSlug = null;
    },
    setChileSlug: (state, action: PayloadAction<ITaskSlug>) => {
      state.childSlug = action.payload;
    },
    resetChildSlug: state => {
      state.childSlug = null;
    },
  },
});

export const {setParentSlug, resetParentSlug, setChileSlug, resetChildSlug} =
  taskInnerSwitchSlice.actions;
export default taskInnerSwitchSlice.reducer;
